require.context("../images", true);
import "src/decidim/extra_user_fields/signup_form";
import "src/decidim/extra_user_fields/accessible_datepicker";
